/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import User from '@/core/user'

export default {
  setup() {
    const user = User.get()
    // Config
    global.intercomUpdateCalls = 1
    global.intercomSettings = {
      app_id        : process.env.INTERCOM_APP,
      name          : user.name,
      email         : user.username,
      user_hash     : user.intercom_hash,
      created_at    : new Date(
                        user.created
                          .replace(/ /, 'T')
                          .replace(/\.\d+/, '')
                      ).getTime() / 1000,

      is_fusion     : user.flags.hasFusion,
      has_reporting : user.flags.hasReporting,

      hide_default_launcher: !user.flags.hasIntercomChat
    }
  },

  track(event) {
    if (typeof global.Intercom === 'undefined') return
    global.Intercom('trackEvent', event)
  },

  show(visibility) {
    if (typeof global.Intercom === 'undefined') return
    const user = User.get()

    setTimeout(() => {
      global.Intercom('update', {
        hide_default_launcher: visibility === false || user && !user.flags.hasIntercomChat
      })
    }, 100)
  },

  hide() {
    this.show(false)
  },

  logout() {
    if (typeof global.Intercom === 'undefined') return
    global.Intercom('shutdown')
  },

  init() {
    if (typeof global.Intercom !== 'undefined') return

    // Init snippet
    var w = window
    var ic = w.Intercom
    if (typeof ic === 'function') {
      ic('reattach_activator')
      ic('update', global.intercomSettings)
    } else {
      var d = document
      var i = function () {
        i.c(arguments)
      }
      i.q = []
      i.c = function (args) {
        i.q.push(args)
      }
      w.Intercom = i
      var l = function l() {
        var s = d.createElement('script')
        s.type = 'text/javascript'
        s.async = true
        s.src = 'https://widget.intercom.io/widget/' + process.env.INTERCOM_APP
        var x = d.getElementsByTagName('script')[0]
        x.parentNode.insertBefore(s, x)
      }
      /* if (w.attachEvent) {
        w.attachEvent('onload', l)
      } else {
        w.addEventListener('load', l, false)
      } */
      l()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/intercom/index.js